import { render, staticRenderFns } from "./MainLedgerView2.vue?vue&type=template&id=9df6213a"
import script from "./MainLedgerView2.vue?vue&type=script&lang=js"
export * from "./MainLedgerView2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports